import script from "./WishPhotoInput.vue?vue&type=script&setup=true&lang=js"
export * from "./WishPhotoInput.vue?vue&type=script&setup=true&lang=js"

import "./WishPhotoInput.vue?vue&type=style&index=0&id=20b941b5&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/reenarafiq/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b941b5"]])

export default __exports__